"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withJsxExport = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
var toPairs_1 = tslib_1.__importDefault(require("lodash/toPairs"));
var hoist_non_react_statics_1 = tslib_1.__importDefault(require("hoist-non-react-statics"));
var sdk_model_1 = require("@gooddata/sdk-model");
var getDisplayName = function (WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
};
/**
 * @internal
 */
exports.withJsxExport = function (Component) {
    var _a;
    var result = (_a = /** @class */ (function (_super) {
            tslib_1.__extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.toJsx = function () {
                    var stringifiedProps = toPairs_1.default(_this.props)
                        // we ignore functions as there is no bullet-proof to serialize them
                        .filter(function (_a) {
                        var _ = _a[0], value = _a[1];
                        return !isFunction_1.default(value);
                    })
                        .map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return isString_1.default(value) ? key + "=\"" + value + "\"" : key + "={" + sdk_model_1.factoryNotationFor(value) + "}";
                    });
                    var paddedPropDeclarations = stringifiedProps.join("\n").replace(/^/gm, "    ");
                    return "<" + getDisplayName(Component) + "\n" + paddedPropDeclarations + "\n/>";
                };
                return _this;
            }
            class_1.prototype.render = function () {
                return react_1.default.createElement(Component, tslib_1.__assign({}, this.props));
            };
            return class_1;
        }(react_1.default.Component)),
        _a.displayName = "WithJsxExport(" + getDisplayName(Component) + ")",
        _a);
    hoist_non_react_statics_1.default(result, Component);
    return result;
};
//# sourceMappingURL=withJsxExport.js.map